<template>
    <div class="contactPage" @scroll="scrollT($event)" ref="contactPage">
         <div class="pagebox">
             <!-- 联系我们 -->
              <div clang="lianxi">
                  <div class="title">
                        <div class="titleText">{{$t('language.contact')}}</div>
                        <div class="titleLine"></div>
                   </div>
                   <div v-html="contactData"></div>
                </div>
                <!-- 商务与合作 -->
                <div class="cooperation">
                    <div class="title">
                        <div class="titleText">{{$t('language.Cooperation')}}</div>
                        <div class="titleLine"></div>
                    </div>
                    <div v-html="CooperData"></div>
                </div>
         </div>
         <div style="height:20px;"></div>
        <div class="footer">
        	<div class="footerCon"  ref="footerCon" >
				<div style="padding-top: 5px;padding-bottom: 5px;"><a href='https://218.26.86.27:8067/ei/Ei!certificate.action?id=9028ffb17604406e01761864b3aa0010' target='_blank' style='border:0;height: 36px;'><img src='../../assets/image/shichang.png' style='border:0;height: 100%;width: 100%;'/></a></div>
        	    <div class="address"><div>地址: {{address}}</div></div>
        	    <div class="email"><div>邮箱:{{email}}</div></div>
        		<div class="email"><div><a href="https://beian.miit.gov.cn/" style="color: rgba(0, 0, 0, .7);text-decoration: none;">
						  <span>ICP备：晋ICP备18006634号-1</span>
						</a></div></div>
        	</div>
        </div>
        <Fixed :goTop="gotoT"></Fixed>
    </div>
</template>
<script>
import Fixed from '../../components/fixed.vue';
export default {
    name:'contactInfo',
    data(){
        return{
                center: [112.176016,37.204044],
                zoom: 15,
                label:{
                    content: '山西省晋中市平遥县西大街214号',
                    offset:[10,12]
                },
                centerTwo: [112.536592,37.829027],
                zoomTwo: 15,
                labelTwo:{
                    content: '山西省太原市万柏林区滨河西路南段109号汇锦花园',
                    offset:[10,12]
                },
                scrollTopH:0,
                contactData:'',
			    CooperData:'',
				address:'',
				email:''
        }
    },
    components:{
       Fixed
    },
	created() {
		this.$fetch('/index/info').then(res => {
			this.address = res.data.address;
			this.email = res.data.email;
		})
	},
    mounted(){
        this.getContact();
        this.getCooper();
    },
    methods:{
         // 初始化地图
        initMap (map) {
            var map = new AMap.Map("container", {
                zoomEnable:true, //是否禁止缩放
                zoom: 12, //缩放比例
                dragEnable: false,//禁止拖动
                cursor: 'hand' // 鼠标在地图上的表现形式，小手
            });
            var map = new AMap.Map("containerTwo", {
                zoomEnable:true, //是否禁止缩放
                zoom: 12, //缩放比例
                dragEnable: false,//禁止拖动
                cursor: 'hand' // 鼠标在地图上的表现形式，小手
            });
            // 初始化工具条
            map.plugin(["AMap.ToolBar"], function() {
                map.addControl(new AMap.ToolBar());
            });
        },
        // 侧边菜单显示
       scrollT(event){
           this.scrollTopH = event.target.scrollTop;
           let fixCon = document.getElementsByClassName("fixed")[0];
           if(this.scrollTopH>500){
               fixCon.style.opacity = "1"
           }else{
               fixCon.style.opacity = "0"
           }
       },
       // 顶部
       gotoT(){
          this.$refs.contactPage.scrollTop = 0;
       },
       // 获取初始化数据
       getContact(){
        this.$fetch('Content/getContactUs').then(res => {
            if(res.code == 200){
                console.log(res.data.data)
                this.contactData = res.data.info;
            }
        })
      },
      getCooper(){
        this.$fetch('Content/getBusiness').then(res => {
            if(res.code == 200){
                this.CooperData = res.data.info;
            }
        })
      }
    }
}
</script>
<style scoped>
.contactPage{
    width: 100%;
    font-family: Microsoft YaHei;
    height: 80vh;
    overflow: auto;
}
.pagebox{
    width: 80%;
    margin:0 auto;
}
.title{
    margin:38px 0px 40px 0px;
    text-align: left;
}
.titleText{
    font-size: 42px;
    font-weight: bold;
    color: #000000;
    padding-bottom: 14px;
}
.titleLine{
    width: 53px;
    height: 6px;
    background: #000000;
}
.mapInfo{
    width: 100%;
    height: 725px;
    display: flex;
    justify-content: space-between;
}
.mapbox{
    width: 827px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.mapText{
    width: 623px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.mapText>div{
    width: 100%;
    height: 46%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
.mapItem{
    width: 100%;
    height: 47%;
}
.infoText{
    font-size: 16px;
    font-weight: 400;
    color: #000000;
    line-height: 30px;
}
.cooperText{
    width: 827px;
}
.cooperTitle{
    width: 100%;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #141212;
}
.cooperCon{
    width: 100%;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #100F0F;
    padding:20px 0px;
    line-height: 26px;
}
.cooperInfo{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.downLoad{
    width: 360px;
    height: 48px;
    background: #AF011A;
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    margin-top: 10px;
}
.mediaInfo{
    width: 610px;
    height: 400px;
}
.qrcodeImg{
    width: 271px;
    height: 263px;
}
.footer{
	width: 100%;
	height: 42px;
	background: rgba(245, 245, 245, 1);
	position: absolute;
	bottom: 0%;
	left:0%;
}

.footerCon{
    width: 45%;
    height: 42px;
    background: rgba(245, 245, 245, 1);
    position: absolute;
    bottom: 0%;
    left:0%;
	right: 0;
	margin: auto;
    font-size: 14px;
    font-weight: bold;
    color: #3D3D3B;
    display: flex;
    justify-content: space-around;
}
@media screen and (max-width:1600px){
	.footerCon{
		width: 63%!important;
	}
}
@media screen and (max-width:1300px){
	.footerCon{
		width: 60%!important;
	}
}
@media screen and (max-width:900px){
	.footerCon{
		width: 70%!important;
	}
}
.footerCon>div{
    display: flex;
    align-items: center;
}
.address{
    margin-right: 100px;
}
.address img{
    width: 20px;
    height: 22px;
    margin-right: 10px;
}
.email img{
    width: 19px;
    height: 14px;
    margin-right: 10px;
}
.fixed{
    position: fixed;
    right: 86px;
    bottom: 90px;
    transition: all 1s;
    opacity: 0;

}
.fixItem{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    /* background: #020101; */
    color: #020101;
    margin-top: 10px;
}
.fixItem:nth-of-type(1){
    background: #000000;
    color: #FFFFFF;
}
.fixItem>img{
    width:28px;
    height: 28px;
}
.fixText{
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    margin-top: 3px;
}
</style>



// WEBPACK FOOTER //
// src/pages/newPage/contactInfo.vue